var options={add:false,addTo:'panels'};export default options;